/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as R404RouteImport } from './routes/404'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedUploadBankReportRouteImport } from './routes/_authenticated/upload-bank-report'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAccessManagementRouteImport } from './routes/_authenticated/access-management'
import { Route as AuthenticatedLeadListRouteImport } from './routes/_authenticated/lead/list'
import { Route as AuthenticatedLeadCreateRouteImport } from './routes/_authenticated/lead/create'
import { Route as AuthenticatedLeadEditLeadIdRouteImport } from './routes/_authenticated/lead/edit.$leadId'

const AuthenticatedUsersLazyRouteImport = createFileRoute(
  '/_authenticated/users',
)()

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsersLazyRoute = AuthenticatedUsersLazyRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/users.lazy').then((d) => d.Route),
)
const AuthenticatedUploadBankReportRoute =
  AuthenticatedUploadBankReportRouteImport.update({
    id: '/upload-bank-report',
    path: '/upload-bank-report',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccessManagementRoute =
  AuthenticatedAccessManagementRouteImport.update({
    id: '/access-management',
    path: '/access-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeadListRoute = AuthenticatedLeadListRouteImport.update({
  id: '/lead/list',
  path: '/lead/list',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLeadCreateRoute = AuthenticatedLeadCreateRouteImport.update({
  id: '/lead/create',
  path: '/lead/create',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLeadEditLeadIdRoute =
  AuthenticatedLeadEditLeadIdRouteImport.update({
    id: '/lead/edit/$leadId',
    path: '/lead/edit/$leadId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/access-management': typeof AuthenticatedAccessManagementRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/upload-bank-report': typeof AuthenticatedUploadBankReportRoute
  '/users': typeof AuthenticatedUsersLazyRoute
  '/lead/create': typeof AuthenticatedLeadCreateRoute
  '/lead/list': typeof AuthenticatedLeadListRoute
  '/lead/edit/$leadId': typeof AuthenticatedLeadEditLeadIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/access-management': typeof AuthenticatedAccessManagementRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/upload-bank-report': typeof AuthenticatedUploadBankReportRoute
  '/users': typeof AuthenticatedUsersLazyRoute
  '/lead/create': typeof AuthenticatedLeadCreateRoute
  '/lead/list': typeof AuthenticatedLeadListRoute
  '/lead/edit/$leadId': typeof AuthenticatedLeadEditLeadIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_authenticated/access-management': typeof AuthenticatedAccessManagementRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRoute
  '/_authenticated/upload-bank-report': typeof AuthenticatedUploadBankReportRoute
  '/_authenticated/users': typeof AuthenticatedUsersLazyRoute
  '/_authenticated/lead/create': typeof AuthenticatedLeadCreateRoute
  '/_authenticated/lead/list': typeof AuthenticatedLeadListRoute
  '/_authenticated/lead/edit/$leadId': typeof AuthenticatedLeadEditLeadIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/login'
    | '/unauthorized'
    | '/access-management'
    | '/dashboard'
    | '/reports'
    | '/upload-bank-report'
    | '/users'
    | '/lead/create'
    | '/lead/list'
    | '/lead/edit/$leadId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/login'
    | '/unauthorized'
    | '/access-management'
    | '/dashboard'
    | '/reports'
    | '/upload-bank-report'
    | '/users'
    | '/lead/create'
    | '/lead/list'
    | '/lead/edit/$leadId'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/_authenticated'
    | '/login'
    | '/unauthorized'
    | '/_authenticated/access-management'
    | '/_authenticated/dashboard'
    | '/_authenticated/reports'
    | '/_authenticated/upload-bank-report'
    | '/_authenticated/users'
    | '/_authenticated/lead/create'
    | '/_authenticated/lead/list'
    | '/_authenticated/lead/edit/$leadId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/upload-bank-report': {
      id: '/_authenticated/upload-bank-report'
      path: '/upload-bank-report'
      fullPath: '/upload-bank-report'
      preLoaderRoute: typeof AuthenticatedUploadBankReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/access-management': {
      id: '/_authenticated/access-management'
      path: '/access-management'
      fullPath: '/access-management'
      preLoaderRoute: typeof AuthenticatedAccessManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/lead/list': {
      id: '/_authenticated/lead/list'
      path: '/lead/list'
      fullPath: '/lead/list'
      preLoaderRoute: typeof AuthenticatedLeadListRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/lead/create': {
      id: '/_authenticated/lead/create'
      path: '/lead/create'
      fullPath: '/lead/create'
      preLoaderRoute: typeof AuthenticatedLeadCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/lead/edit/$leadId': {
      id: '/_authenticated/lead/edit/$leadId'
      path: '/lead/edit/$leadId'
      fullPath: '/lead/edit/$leadId'
      preLoaderRoute: typeof AuthenticatedLeadEditLeadIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAccessManagementRoute: typeof AuthenticatedAccessManagementRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRoute
  AuthenticatedUploadBankReportRoute: typeof AuthenticatedUploadBankReportRoute
  AuthenticatedUsersLazyRoute: typeof AuthenticatedUsersLazyRoute
  AuthenticatedLeadCreateRoute: typeof AuthenticatedLeadCreateRoute
  AuthenticatedLeadListRoute: typeof AuthenticatedLeadListRoute
  AuthenticatedLeadEditLeadIdRoute: typeof AuthenticatedLeadEditLeadIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccessManagementRoute: AuthenticatedAccessManagementRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRoute,
  AuthenticatedUploadBankReportRoute: AuthenticatedUploadBankReportRoute,
  AuthenticatedUsersLazyRoute: AuthenticatedUsersLazyRoute,
  AuthenticatedLeadCreateRoute: AuthenticatedLeadCreateRoute,
  AuthenticatedLeadListRoute: AuthenticatedLeadListRoute,
  AuthenticatedLeadEditLeadIdRoute: AuthenticatedLeadEditLeadIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
